import styled from "styled-components";

import {
  alignItemsCenter,
  alpha,
  bp,
  circle,
  fileAcceptAnimation,
  fileRejectAnimation,
  flexCenter,
  flexColumn,
  flexSpBetween,
  media,
  pseudo,
  rem,
} from "@styles/Utilities.styled";


export const StyledGeneralConsultation = styled.section`
  margin-bottom: 8rem;

  .header {
    ${flexSpBetween}
    align-items: end;
    padding-top: 2rem;
    padding-bottom: 1rem;
    border-bottom: 1px solid ${alpha("var(--clr-black)", 0.1)};

    &.sticky {
      /* position: sticky; */
      /* top: 0; */
      background-color: var(--clr-white);
      /* z-index: 9; */
    }

    .back-btn-wrapper {
      ${flexColumn}
      gap: 0.35rem;

      .back-btn {
        ${alignItemsCenter}
        gap: 0.5rem;
        color: var(--clr-primary-400);
        font-size: ${rem(15)};

        svg {
          fill: var(--clr-primary-400);
        }
      }
    }

    h2 {
      font-weight: 500;
      font-size: ${rem(20)};
    }
  }

  .content {
    display: flex;
    flex-direction: column;
    gap: 2rem;
    margin-top: 2rem;
    overflow: hidden;

    ${media(bp.large2)} {
      flex-direction: row;
      margin-top: 3rem;
    }
  }

  .stepper {
    --gap: 0rem;

    display: flex;
    gap: var(--gap);
    max-width: calc(100vw - var(--sidebar-width) - 5rem);
    overflow: auto;
    /* outline: 1px solid red; */

    ${media(bp.large2)} {
      --gap: 2.5rem;

      flex-direction: column;
      flex-basis: 30%;
      max-width: ${rem(270)};
    }

    &-item {
      button {
        --circle-size: calc(${rem(15)} * 2.2);

        position: relative;
        ${flexColumn}
        align-items: center;
        gap: 0.75rem;
        min-width: ${rem(95)};
        max-width: ${rem(100)};
        text-align: center;
        color: var(--clr-gray-300);
        line-height: 1.4;

        ${media(bp.medium)} {
          --circle-size: calc(${rem(15)} * 2.4);
        }

        ${media(bp.large2)} {
          --circle-size: calc(${rem(15)} * 2.6);
          flex-direction: row;
          text-align: left;
          max-width: unset;
        }

        &::before {
          ${pseudo}
          top: calc(var(--circle-size) / 2);
          left: calc(100% - (1.5rem / 2));
          transform: translateY(-50%);
          height: 2px;
          width: calc(var(--gap) + 1.5rem);
          background-color: var(--clr-gray-175);
          border-radius: 100vmax;
          z-index: -1;

          ${media(bp.large2)} {
            top: calc(100% + (var(--gap) / 2));
            left: calc(var(--circle-size) / 2);
            width: 2px;
            height: calc(var(--gap) / 1.5);
          }
        }

        &.completed {
          color: var(--green-11);

          &::before {
            background-color: var(--green-11);
          }

          .icon-wrapper {
            border-color: rgb(0, 0, 0, 0);
            background-color: var(--green-3);
            color: var(--green-11);
          }
        }

        &.active {
          color: var(--clr-primary-400);

          &::before {
            background-color: var(--clr-primary-400);
          }

          .icon-wrapper {
            background-color: var(--clr-primary-400);
            color: var(--clr-white);
            border-color: var(--clr-primary-400);
          }
        }

        span {
          /* Adding these styles positions the asterisk weirdly for text with 2 words */
          /* display: inline-flex; */
          /* align-items: start; */

          font-size: ${rem(13)};
          font-weight: 500;

          ${media(bp.medium)} {
            font-size: ${rem(14)};
          }
          ${media(bp.large2)} {
            font-size: ${rem(15)};
          }

          sup {
            color: red;
          }
        }
      }

      .icon-wrapper {
        --font-size: ${rem(15)};

        position: relative;
        ${flexCenter}
        ${circle("var(--circle-size)")}
          font-size: var(--font-size);
        border: 2px solid var(--clr-gray-200);
        z-index: 2;
        background-color: var(--clr-white);

        ${media(bp.large2)} {
          min-width: var(--circle-size);
        }

        span {
          font-size: ${rem(14)};
          text-align: center;
          font-weight: 400;
        }
      }

      &:last-child {
        button::before {
          content: none;
        }
      }
    }
  }

  .form {
    ${media(bp.large2)} {
      flex-basis: 70%;
      flex-grow: 1;
      margin-top: 0;
    }

    &-step {
      ${flexColumn}
      gap: 1.5rem;
    }

    &-group {
      align-items: start;
      gap: 1rem;

      ${media(bp.medium)} {
        gap: 2rem;
      }
    }

    &-field {
      .combined {
        ${flexColumn}
        gap: 0.5rem;
      }

      .input-wrapper {
        ${alignItemsCenter}
        gap: 1rem;
      }
    }

    &-field {
      &.half {
        ${media(bp.medium)} {
          width: calc(50% - 1rem);
        }
      }
    }
  }

  .files-wrapper {
    margin-top: 2rem;
    font-size: ${rem(14)};

    .dropzone {
      ${flexCenter}
      height: ${rem(150)};
      padding: 1rem;
      background-color: var(--clr-gray-100);
      border: 1px dashed var(--clr-primary-700);
      border-radius: var(--border-radius-2);
      cursor: pointer;

      &.active {
        border: 2px dashed var(--clr-primary-400);
      }

      &.accept {
        background-color: var(--green-3);
        border-color: var(--green-8);
        animation: ${fileAcceptAnimation} 1s var(--ease-slow-start) forwards;
      }

      &.reject {
        background-color: ${alpha("var(--clr-rose)", 0.15)};
        border-color: ${alpha("var(--clr-rose)", 0.8)};
        animation: ${fileRejectAnimation} 0.1s ease-out 4 forwards;
      }

      .text-content {
        ${flexColumn}
        align-items: center;
        gap: 1rem;

        .p-wrapper {
          text-align: center;

          p:first-child {
            font-weight: 500;
          }
          p:last-child {
            font-size: ${rem(13)};
            color: var(--clr-gray-400);
          }
        }

        .svg-wrapper {
          ${flexCenter}
          ${circle(rem(55))}
          background-color: ${alpha("var(--clr-primary-400)", 0.1)};
        }

        svg {
          font-size: 1.75rem;
        }
      }
    }

    .uploaded-files {
      margin-top: 2rem;

      h4 {
        font-weight: 500;
      }

      ul {
        ${flexColumn}
        gap: 0.5rem;
        margin-top: 1rem;

        li {
          ${flexSpBetween}
          gap: 1rem;
          padding: 0.5rem 1rem;
          border: 1px solid var(--clr-gray-175);
          border-radius: var(--border-radius-2);

          .file-content {
            ${alignItemsCenter}
            gap: 0.5rem;
            margin-top: 0 !important;

            p {
              line-height: 1.2;
            }

            svg {
              font-size: 1.5rem;
            }
          }
        }
      }
    }
  }

  .table {
    margin-top: 1rem;

    &-header,
    &-row {
      display: flex;
      /* height: ${rem(62)}; */
      padding-block: 0.9em;
      padding-left: 0.5em;
      border: 1px solid var(--clr-gray-175);

      ${media(bp.medium)} {
        padding-left: 1em;
      }

      & > :first-child {
        flex-basis: 42.5%;
        /* outline: 1px solid red; */

        ${media(bp.medium)} {
          flex-basis: 40%;
        }

        ${media(bp.large2)} {
          flex-basis: 35%;
        }
      }

      & > :nth-child(2) {
        /* flex-basis: 42.5%; */
        /* outline: 1px solid blue; */

        ${media(bp.medium)} {
          flex-basis: 45%;
        }

        ${media(bp.large2)} {
          flex-basis: 55%;
        }
      }

      & > :last-child {
        flex-grow: 1;
        /* flex-basis: 50%; */
        display: flex;
        justify-content: end;
        padding-right: 1rem;
        /* outline: 1px solid purple; */

        ${media(bp.medium)} {
          flex-basis: 15%;
        }
        /* outline: 1px solid red; */
      }

      p {
        align-self: center;
        font-weight: 600;

        &:nth-child(2) {
          display: none;

          ${media(bp.medium)} {
            display: block;
          }
        }
      }
    }

    &-header {
      background-color: var(--clr-gray-100);
    }

    li + li {
      border-top: none;
    }

    &-row {
      p {
        font-weight: 400;
        font-size: ${rem(14)};
      }

      div {
        ${flexCenter}
      }
    }
  }

  .footer {
    ${flexSpBetween}
    padding-top: 1rem;
    margin-top: 3rem;
    gap: 2rem;
    border-top: 1px solid var(--clr-gray-175);

    .wrapper {
      ${alignItemsCenter}
      gap: 1rem;
    }
  }

  .reason-templates {
    display: flex;
    flex-flow: row wrap;
    gap: 0.5rem;
    margin-top: 0.5rem;

    button {
      font-size: ${rem(13)};
      border-radius: 100vmax;
      background-color: var(--clr-primary-400);
      padding: 0.2em 1em;
      color: white;
    }
  }
`;
